import { createAction } from 'redux-actions';

import { openFailedAlert } from 'actions/alert';
import { wrapFetchAuth } from 'actions/endpoint';

import { t } from 'util/i18n';
import { examCreditData, creditKeyFrom } from 'util/exam';

export const generateCreditData = creditForm => ({
	card_number: creditForm.cardNumber.value,
	expiry_year: creditForm.expireYear.value,
	expiry_month: creditForm.expireMonth.value,
	security_code: creditForm.cvc.value,
	credit_name: creditForm.name.value,
});

export const validateOrderCreditData = createAction('VALIDATE_ORDER_CREDIT_DATA', (key, valid) => ({
	key,
	valid,
}));

export const clearValidateOrderCreditData = createAction('CLEAR_VALIDATE_ORDER_CREDIT_DATA');

export const addCreditCard = createAction('ADD_CREDIT_CARD', () => async (dispatch, getState) => {
	const { booking: { creditForm } } = getState();

	const creditData = generateCreditData(creditForm);

	const creditCheckData = examCreditData(creditData);

	dispatch(clearValidateOrderCreditData());

	if (!creditCheckData.value) {
		if (creditCheckData.notValid.includes('card_number')) {
			dispatch(validateOrderCreditData('cardNumber', false));
			window.scrollTo(0, 0);
			throw openFailedAlert('booking', t('booking:notValidCreditNumber'));
		}

		if (
			creditCheckData.notValid.includes('expiry_year') ||
			creditCheckData.notValid.includes('expiry_month')
		) {
			dispatch(validateOrderCreditData('expireYear', false));
			dispatch(validateOrderCreditData('expireMonth', false));
			window.scrollTo(0, 0);
			throw openFailedAlert('booking', t('booking:notValidCreditDate'));
		}

		if (creditCheckData.notValid.includes('security_code')) {
			dispatch(validateOrderCreditData('cvc', false));
			window.scrollTo(0, 0);
			throw openFailedAlert('booking', t('booking:notValidCreditCVC'));
		}

		const notValidData = creditKeyFrom(creditCheckData.notValid);
		notValidData.forEach(key => dispatch(validateOrderCreditData(key, false)));
		window.scrollTo(0, 0);
		throw openFailedAlert('booking', t('booking:notValidCreditNumber'));
	}

	const { status, message } = await wrapFetchAuth('user/addCreditCard', {
		method: 'POST',
		body: JSON.stringify(creditData),
	});

	if (status !== 200 && status !== 201) {
		if (message === 'credit card number error') {
			throw openFailedAlert('booking', t('booking:notValidCreditNumber'));
		}

		if (message === 'credit card expired') {
			throw openFailedAlert('booking', t('booking:expiredCreditCard'));
		}

		throw openFailedAlert('booking', message);
	}
});



// WEBPACK FOOTER //
// ./src/actions/payment.js